import CatalogList from './CatalogList.vue';

export { CatalogList };
export default CatalogList;
